import { Selector } from "./selectors"

export const ProductSelector = Selector


// WEBPACK FOOTER //
// ./src/state/product/selectors/index.ts